import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import collapsedIcon from '../../assets/images/collapse_icon.svg';
import menuIcon from '../../assets/images/menu_icon.svg';
import ConnectWalletBtn from '../../components/common/ConnectWalletBtn';
import useWeb3Ctx from '../../hooks/useWeb3Ctx';
import useAppCtx from '../../hooks/useAppCtx';
import logo from '../../assets/images/ens-logo.svg';
import title from '../../assets/images/title.png';

import {
  Box,
  useMediaQuery,
  Button,
  Typography,
  Collapse,
} from '@mui/material';
import HeaderButton from './components/HeaderButton';

const BP1 = '@media (max-width: 999px)';
const BP3 = '@media (max-width: 1480px) and (min-width:1199px)';
const BP4 = '@media (min-width: 999px)';
const BP5 = '@media (max-width: 500px)';

const COLOR_CYAN = '#19A8B4';

const sx = {
  root: {
    zIndex: 201,
    position: 'sticky',
    height: '130px',
    top: 0,
    width: '100%',
    [BP1]: {
      display: 'none',
    },
    px: '20px',
  },
  content: {
    position: 'relative',
    width: '100%',
    maxWidth: '1158px',
    mx: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '0 28px',
    [BP1]: {
      height: '48px',
      gap: '0 24px',
      pr: '0px',
    },
    [BP3]: {
      maxWidth: '920px',
      gap: '0 14px',
    },
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    [BP1]: {
      display: 'none',
    },
  },
  ButtonHolder: {
    pt: '20px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  divider: {
    maxWidth: '1158px',
    mx: 'auto',
    [BP3]: {
      maxWidth: '920px',
    },
  },
  menuBtn: {
    width: '48px',
    minWidth: '48px',
    display: 'none',
    ml: '8px',
    cursor: 'pointer',
    [BP1]: {
      display: 'block',
      zIndex: '1',
    },
  },
  closeBtn: {
    width: '36px',
    minWidth: '36px',
    ml: '8px',
    mt: '8px',
    cursor: 'pointer',
  },
  menu: {
    width: '100%',
    maxWidth: '312px',
    boxShadow: '4px 0 6px 0 rgba(0,0,0,0.25)',
    backgroundColor: '#FFF',
  },
  logoContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pt: '15px',
  },
  logo: {
    fontFamily: 'amallia',
    fontSize: '44px',
    lineHeight: '55px',
    color: '#3F4B0C',
    cursor: 'pointer',
  },
  mobileContainer: {
    display: 'none',

    [BP1]: {
      display: 'block',
      gap: '30px',
      height: '130px',
      width: '100%',
    },
  },
  headerRoot: {
    position: 'relative',
    width: '100%',
    pl: '35px',
    pr: '19px',
    zIndex: '1001',
    maxWidth: '1272px',
    height: '124px',
    mx: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [BP1]: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
    },
  },
  collapsedMenu: {
    position: 'fixed',
    zIndex: '2222',
    width: 'fit-content',
    minHeight: '150px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    right: '0',
    borderBottomLeftRadius: '12px',
    backgroundColor: '#F2EFE0 ',
    px: '50px',
    top: '124px',
    pb: '10px',
    pt: '0px',
  },
  menuContainer: {
    height: '25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '9px 0',
    zIndex: '1',
    mt: '-11px',
  },
  menuList: {
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    width: '155px',
    height: '168px',
    position: 'absolute',
    fontSize: '16px',
    boxShadow: '2px 2px 2px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: '6px',
    pt: '10px',
    pb: '0',
  },
  imgContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '446px',
    cursor: 'pointer',
  },
  logoContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const BUTTONS = ['Collection', 'Wallet', 'Forge'];
const PATHS = ['/#collection', '/wallet', '/forge'];

function getYPosition() {
  var top = window.pageYOffset || document.documentElement.scrollTop;
  return top;
}

const Header = ({ clickedToTheSameLink }) => {
  const { handleConnect, handleDisconnect, address, isCorrectNetwork } =
    useWeb3Ctx();
  const { txPending } = useAppCtx();
  const rootRef = useRef(null);
  const [isFixed, setFixed] = useState(false);
  const history = useHistory();
  const isMobileView = useMediaQuery('(max-width: 999px)');
  const [activeTab, setActiveTab] = useState(null);
  const [menuOpened, setMenuOpened] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showMenuBgr, setShowMenuBgr] = useState(false);
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 600) {
      setMobileView(true);
    }
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        if (rootRef.current) {
          const { top } = rootRef.current.getBoundingClientRect();
          setFixed(top <= 0 && window.scrollY !== 0);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offsetDesktop = showMenuBgr ? 60 : 100;
      const offsetMobile = showMenuBgr ? 210 : 100;
      if (getYPosition() > offsetDesktop && !mobileView) {
        setShowMenuBgr(true);
      } else if (getYPosition() > offsetMobile && mobileView) {
        setShowMenuBgr(true);
      } else {
        setShowMenuBgr(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [mobileView, showMenuBgr]);

  const handleNavigation = (path) => {
    if (PATHS[path] === '/' + location.hash) {
      clickedToTheSameLink();
    }
    console.log(PATHS[path], location.hash);
    if (location.pathname !== path) {
      history.push(path);
      history.push(PATHS[path]);
    }
  };
  const handleMouseOver = (path) => {
    setActiveTab(path);
  };
  const handleMouseLeave = () => {
    console.log(location.hash);
    if (location.hash === '#/#collection') {
      setActiveTab(0);
    } else if (location.hash === '#/#redemption') {
      setActiveTab(1);
    } else if (location.hash === '#/wallet') {
      setActiveTab(2);
    } else if (location.hash === '#/forge') {
      setActiveTab(3);
    } else {
      setActiveTab(null);
    }
  };

  useEffect(() => {
    if (location.hash === '#/#collection') {
      setActiveTab(0);
    } else if (location.hash === '#/#redemption') {
      setActiveTab(1);
    } else if (location.hash === '#/wallet') {
      setActiveTab(2);
    } else if (location.hash === '#/forge') {
      setActiveTab(3);
    } else {
      setActiveTab(null);
    }
  }, [location.hash]);

  const handleNavigationLogo = (path) => {
    setActiveTab(null);
    window.location.hash = '';
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    });
    if (location.pathname !== path) {
      history.push(path);
      history.push(PATHS[path]);
    }
  };

  return (
    <>
      <Box
        sx={{
          ...sx.root,
          backgroundPosition: isFixed ? '0px -100%' : '0px 0px;',
          backgroundSize: '100% 200%',
          // transition:
          //   "background-position 0.1s ease 0s, box-shadow 0.2s ease 0s",
          // boxShadow: isFixed ? "0 4px 4px 0 rgba(0,0,0,0.3)" : "unset",
          background: txPending && 'rgb(81, 87, 255)',
        }}
        style={{
          backgroundColor: showMenuBgr ? '#f0ecddbf' : 'transparent',
          marginTop: showMenuBgr ? '-40px' : '',
        }}
        ref={rootRef}
      >
        <Box sx={sx.content}>
          <Box sx={sx.imgContainer} onClick={() => handleNavigationLogo('/')}>
            <img
              src={title}
              style={{ width: '100%', marginTop: '0px', margin: '0 auto' }}
              alt="image"
            />
          </Box>

          <Box sx={sx.btnContainer}>
            <Box sx={sx.ButtonHolder}>
              {BUTTONS.map((btn, i) => {
                return (
                  <HeaderButton
                    key={btn}
                    active={activeTab === i}
                    text={btn}
                    onClick={() => handleNavigation(i)}
                    onMouseOver={() => handleMouseOver(i)}
                    onMouseLeave={handleMouseLeave}
                  />
                );
              })}
            </Box>
            <ConnectWalletBtn />
          </Box>
        </Box>
      </Box>
      <Box sx={sx.mobileContainer}>
        <Box
          sx={sx.headerRoot}
          style={{
            backgroundColor: showMenuBgr ? '#f0ecddbf' : 'transparent',
            top: showMenuBgr ? 0 : '',
          }}
        >
          <Box
            sx={sx.logoContainer}
            style={{ marginTop: '6px' }}
            onClick={() => handleNavigationLogo('/')}
          >
            <Typography sx={sx.logo} onClick={() => handleNavigationLogo('/#')}>
              EC
            </Typography>
          </Box>
          <Box
            sx={sx.menuContainer}
            onClick={() => setMenuOpened((state) => !state)}
          >
            <Button sx={sx.menubtn}>
              <img
                style={{ width: '100%', paddingRight: '10px' }}
                src={menuOpened ? collapsedIcon : menuIcon}
                alt="Menu icon"
              />
            </Button>
          </Box>
        </Box>
        <Collapse in={menuOpened} timeout="auto" unmountOnExit>
          <Box
            sx={sx.collapsedMenu}
            style={{
              backgroundColor: showMenuBgr ? '#f0ecddbf' : '#F4ECDC',
            }}
          >
            {BUTTONS.map((btn, i) => {
              return (
                <HeaderButton
                  key={btn}
                  active={activeTab === i}
                  text={btn}
                  onClick={() => handleNavigation(i)}
                  onMouseOver={() => handleMouseOver(i)}
                  onMouseLeave={handleMouseLeave}
                />
              );
            })}
            <ConnectWalletBtn />
          </Box>
        </Collapse>
      </Box>
    </>
  );
};

export default Header;
